import { render, staticRenderFns } from "./ExpertiseDetails.vue?vue&type=template&id=0848ca3b&scoped=true"
import script from "./ExpertiseDetails.vue?vue&type=script&lang=js"
export * from "./ExpertiseDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseDetails.vue?vue&type=style&index=0&id=0848ca3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848ca3b",
  null
  
)

export default component.exports